<template>
  <rest-list-column
    :prop="prop"
    :title="title"
    :route="route"
    :width="width"
    :min-width="minWidth"
    :formatter="formatter"
    :filter-date-range="isRange"
    :filter-date="!isRange"
    :date-picker-props="datePickerProps"
    :sortable="sortable"
    :fixed="fixed"
    :filterable="filterable"
  />
</template>

<script>
import RestListColumn from '@/common/components/rest/RestListColumn'
import { projectTimezoneDate, isDateFormat } from '@/core/helpers'
import { projectTimezoneTimestamp } from '../../../core/helpers'

export default {
  name: 'RestListColumnDate',

  components: { RestListColumn },

  props: {
    prop: {
      type: String,
      required: true
    },

    unix: {
      type: Boolean,
      default: true
    },

    title: {
      type: String,
      required: true
    },

    readonly: {
      type: Boolean,
      default: false
    },

    route: {
      type: Function,
      required: false
    },

    width: {
      type: Number,
      required: false
    },

    minWidth: {
      type: Number,
      required: false,
      default: 180
    },

    dateFormat: {
      type: String,
      required: false,
      default: 'DD MMM YYYY HH:mm:ss'
    },

    datePickerProps: {
      type: Object,
      required: false,
      default: () => {
        return {
          type: 'datetimerange',
          value_format: 'yyyy-MM-dd HH:mm:ss',
          default_time: ['00:00:00', '23:59:59']
        }
      }
    },

    sortable: {
      required: false
    },

    fixed: {
      type: [Boolean, String],
      required: false,
      default: false
    },

    filterable: {
      type: Boolean,
      default: true
    },

    isRange: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  methods: {
    formatter(value) {
      if (isDateFormat(value)) {
        return value
      }

      if (value) {
        if (this.unix) {
          return projectTimezoneDate(value).format(this.dateFormat)
        }

        return projectTimezoneTimestamp(value).format(this.dateFormat)
      }

      return '-'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestListColumnDate.vue